export default "__VITE_ASSET__GqVLKv$r8Vnhx8e5bK1vqg__"